var indentStyle = {"indentZero":"_9-Qxn","indentOne":"J7ORa","indentTwo":"_3FwYI","indentThree":"EvYKV","indentFour":"pm2dy","indentFive":"_0T-5r","indentSix":"JmHIh"};

export { indentStyle as i };
//# sourceMappingURL=indentation-e06c54bc.js.map
